import { useLazyQuery, gql, TypedDocumentNode } from '@apollo/client';
import React, { useEffect } from 'react';
import { Stack } from '@moda/om';
import { useInView } from 'react-intersection-observer';
import {
  ProductRecommendationsQuery,
  ProductRecommendationsQueryVariables
} from '../../generated/types/ProductRecommendationsQuery';
import { DIVIDER_LAYOUT_TYPES } from '../DividerPumoModule';
import { RecommendationsModule, ALGORITHMS } from '../RecommendationsPumoModule';

export const PRODUCT_RECOMMENDATIONS_QUERY: TypedDocumentNode<
  ProductRecommendationsQuery,
  ProductRecommendationsQueryVariables
> = gql`
  query ProductRecommendationsQuery($variantId: String!) {
    variant(id: $variantId) {
      id
      product_id
      gender
      subcategory
    }
  }
`;

interface Props {
  variantId: string;
}

export const ProductRecommendations: React.FC<Props> = ({ variantId }) => {
  const [ref, inView] = useInView();
  const [runRecommendationsQuery, { data, loading, error }] = useLazyQuery(
    PRODUCT_RECOMMENDATIONS_QUERY,
    {
      variables: { variantId }
    }
  );

  useEffect(() => {
    if (inView && !data && !loading && !error) {
      runRecommendationsQuery();
    }
  }, [inView, data, loading, error, runRecommendationsQuery]);

  const variant = data?.variant;
  const product = {
    gender: variant?.gender,
    subcategory: variant?.subcategory,
    productId: variant?.product_id.toString(),
    variantId: variant?.id
  };

  if (loading || error || !data) return <div ref={ref} />;

  return (
    <>
      {/* TODO: forwardRef inside Stack */}
      <div ref={ref} />

      <Stack space={6}>
        <RecommendationsModule
          algorithm={ALGORITHMS.LOOK_VARIANTS}
          product={product}
          divider={{
            layoutType: DIVIDER_LAYOUT_TYPES.ONE_LINE,
            text: 'How To Wear It'
          }}
        />
        <RecommendationsModule
          algorithm={ALGORITHMS.SIMILAR_PRODUCTS}
          product={product}
          divider={{
            layoutType: DIVIDER_LAYOUT_TYPES.ONE_LINE,
            text: 'Customers Also Viewed'
          }}
        />
        <RecommendationsModule
          algorithm={ALGORITHMS.RECENTLY_VIEWED}
          product={product}
          divider={{
            layoutType: DIVIDER_LAYOUT_TYPES.ONE_LINE,
            text: 'Recently Viewed'
          }}
        />
      </Stack>
    </>
  );
};
